import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared.module";
import { SchoolsSysyrmRoutingModule } from "./schools-sysyrm-routing.module";
import { SchoolsSysyrmComponent } from "./index/schools-sysyrm.component";

@NgModule({
  declarations: [SchoolsSysyrmComponent],
  imports: [CommonModule, SchoolsSysyrmRoutingModule, SharedModule],
  exports: [SchoolsSysyrmComponent],
})
export class SchoolsSysyrmModule {}
